var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frontend"},_vm._l((_vm.cockpits),function(cockpit){return _c('router-link',{key:cockpit.value,staticClass:"cockpitpreview",attrs:{"to":"/cockpit"}},[_c('img',{attrs:{"src":cockpit.img,"alt":"cockpit image"}}),_c('span',[_vm._v(_vm._s(cockpit.name))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }